
<template>
  <div>
    <div class="ui large fixed menu noprint">
      <div class="ui fluid container">
        <a href="#" class="header item">
          qa.solution backend
        </a>
        <div class="right menu noprint">
          <a class="item" v-on:click="getQuestions()">
            <i class="sync icon"></i> reload
          </a>
          <a class="item" v-on:click="exportXlsx()">
            <i class="file excel outline icon"></i> export
          </a>
          <a class="item">
            <i class="notched circle loading icon" v-if="online"></i>
            <i class="red exclamation circle icon" v-else ></i>
          </a>
        </div>
      </div>
    </div>

    <div class="splitcontainer left" :class="{ solo: soloLeft }">
      <div class="ui container">
        <div class="ui secondary pointing menu">
          <a class="item" :class="{ active: left == 'new' }" v-on:click="setLeft('new')">
            Neue Fragen
            <span class="ui red circular label">{{ questionsNew.length }}</span>
          </a>
          <a class="item" :class="{ active: left == 'live' }" v-on:click="setLeft('live')">
            Live
            <span class="ui teal circular label">{{ questionsLive.length }}</span>
          </a>
          <a class="item" :class="{ active: left == 'archive' }" v-on:click="setLeft('archive')">
            Archiv
            <span class="ui grey circular label">{{ questionsArchive.length }}</span>
          </a>
          <div class="right menu noprint">
            <a class="ui item" v-if="!soloLeft" v-on:click="soloLeft = true">
              <i class="window maximize outline icon"></i>
            </a>
            <a class="ui item" v-else v-on:click="soloLeft = false, soloRight = false">
              <i class="columns icon"></i>
            </a>
          </div>
        </div>
        <QuestionsList v-if="left == 'new'" v-bind:questions="questionsNew" />
        <QuestionsList v-if="left == 'live'"  v-bind:questions="sortedLiveArray" />
        <QuestionsList v-if="left == 'archive'"  v-bind:questions="sortedArchiveArray" />
      </div>
    </div>
    <div class="splitcontainer right" :class="{ solo: soloRight }">
      <div class="ui container">
        <div class="ui secondary pointing menu">
          <a class="item" :class="{ active: right == 'live' }" v-on:click="setRight('live')">
            Live
            <span class="ui teal circular label">{{ questionsLive.length }}</span>
          </a>
          <a class="item" :class="{ active: right == 'archive' }" v-on:click="setRight('archive')">
            Archiv
            <span class="ui grey circular label">{{ questionsArchive.length }}</span>
          </a>
          <div class="right menu noprint">
            <a class="ui item" v-if="!soloRight" v-on:click="soloRight = true">
              <i class="window maximize outline icon"></i>
            </a>
            <a class="ui item" v-else v-on:click="soloLeft = false, soloRight = false">
              <i class="columns icon"></i>
            </a>
          </div>
        </div>
        <QuestionsList v-if="right == 'new'" v-bind:questions="questionsNew" />
        <QuestionsList v-if="right == 'live'"  v-bind:questions="sortedLiveArray" />
        <QuestionsList v-if="right == 'archive'"  v-bind:questions="sortedArchiveArray" />
      </div>
    </div>

    <!-- loading -->
    <div id="loadingoverlay" class="ui ui active dimmer" v-if="loading">
      <div class="ui massive text loader">Loading</div>
    </div>
  </div>
</template>

<script>
  import axios from 'axios'
  import moment from 'moment'
  import EventBus from './event-bus';

  import QuestionsList from './QuestionsList'

  export default {
    name: 'Question',
    components: {
      QuestionsList
    },
    data: function() {
      return {
        questions: [],
        archived_questions: [],
        online: false,
        soloLeft: false,
        soloRight: false,
        left: "new",
        right: "live",
        loading: true
      }
    },

    created: function(){
      this.getQuestions();
      this.connectWebSocket();
    },

    mounted() {

      // Instantly move Questions
      EventBus.$on('goArchive', (obj) => {
        let date = new Date();

        this.questions.forEach( (q , idx)=> {
          if (q.id === obj.id ) {
            this.questions[idx].changedAt = obj.changedAt
            this.questions[idx].lastDone = date.toISOString()
            this.questions[idx].archive = true
          }
        })
      })

      EventBus.$on('goForward', (obj) => {
        let date = new Date();

        this.questions.forEach( (q , idx)=> {
          if (q.id === obj.id ) {
            if(this.questions[idx].live) {
              this.questions[idx].lastDone = date.toISOString()
              this.questions[idx].archive = true
            } else {
              this.questions[idx].lastLive = date.toISOString()
              this.questions[idx].live = true
            }
          }
        })
      })

      EventBus.$on('goBack', (obj) => {
        let date = new Date();

        this.questions.forEach( (q , idx)=> {
          if (q.id === obj.id ) {
            if(this.questions[idx].live)
              this.questions[idx].lastLive = date.toISOString()

            if(!this.questions[idx].archive)
              this.questions[idx].live = false
            
            this.questions[idx].archive = false
          }
        })
      })
      
    },

    methods: {
      setLeft(val) {
        this.left = val;
      },

      setRight(val) {
        this.right = val;
      },

      getQuestions() {
        let self = this;

        axios({
          method: 'get',
          url: 'https://s0upkkteth.execute-api.eu-central-1.amazonaws.com/production/questions?streamid='+self.$root.streamid+'&auth='+self.$root.password,
          withCredentials: false,
          crossdomain: true
        })
        .then(function (response) {

          if(response.data.statusCode != 200)
            self.$root.password = null;

          self.questions = JSON.parse(response.data.body);
          self.loading = false;
          self.sortQuestions();
        })
        .catch(function (error) {
          console.log('getData Error', error)
          self.authError = true
          self.loading = false
        })
      },

      sortQuestions() {
        function compare(a, b) {
          let x = new Date(a.timestamp)
          let y = new Date(b.timestamp)

          if (x < y)
            return -1;
          if (x > y)
            return 1;
          return 0;
        }

        this.questions.sort(compare);
      },

      joinRoom: function() {
        const m = {
          "action":"join",
          "streamid": this.$root.streamid,
          "auth": this.$root.password
        };
        this.$root.connection.send( JSON.stringify(m) );
        this.online = true;
      },

      connectWebSocket: function() {
        let self = this;

        this.$root.connection = new WebSocket("wss://68ym4nt7y6.execute-api.eu-central-1.amazonaws.com/production")

        this.$root.connection.onmessage = (event) => {
          self.parseMsg(event.data)
        }

        this.$root.connection.onopen = (event) => {
          clearInterval(this.timerId);

          // keepalive
          this.$root.connection.onclose = () => {
            this.online = false;

            this.timerId = setInterval(() => {
                this.connectWebSocket();
            }, 10000);
          };

          this.joinRoom();
        }
      },

      parseMsg: function(data) {
        let self = this;
        let d = JSON.parse(data);

        console.log("websocket msg", d);

        if(Array.isArray(d))
          d.forEach(function(e) {
            if(e.eventName == "INSERT") {
              if(e.dynamodb.NewImage) {
                let obj = {
                  author: e.dynamodb.NewImage.author.S,
                  email: e.dynamodb.NewImage.email.S,
                  id: e.dynamodb.NewImage.id.S,
                  question: e.dynamodb.NewImage.question.S,
                  streamid: e.dynamodb.NewImage.streamid.S,
                  timestamp: e.dynamodb.NewImage.timestamp.S
                };

                try {
                  obj.modifiedQuestion = e.dynamodb.NewImage.modifiedQuestion.S
                } catch {
                  obj.modifiedQuestion = null
                }

                try {
                  obj.live = e.dynamodb.NewImage.live.BOOL
                } catch {
                  obj.live = false
                }

                try {
                  obj.archive = e.dynamodb.NewImage.archive.BOOL
                } catch {
                  obj.archive = false
                }

                self.questions.push(obj);
              }
            }

            if(e.eventName == "MODIFY") {
              if(e.dynamodb.NewImage) {
                let obj = {
                  author: e.dynamodb.NewImage.author.S,
                  email: e.dynamodb.NewImage.email.S,
                  id: e.dynamodb.NewImage.id.S,
                  question: e.dynamodb.NewImage.question.S,
                  streamid: e.dynamodb.NewImage.streamid.S,
                  timestamp: e.dynamodb.NewImage.timestamp.S
                };

                try {
                  obj.modifiedQuestion = e.dynamodb.NewImage.modifiedQuestion.S
                } catch {
                  obj.modifiedQuestion = null
                }

                try {
                  obj.live = e.dynamodb.NewImage.live.BOOL
                } catch {
                  obj.live = false
                }

                try {
                  obj.archive = e.dynamodb.NewImage.archive.BOOL
                } catch {
                  obj.archive = false
                }

                if(e.dynamodb.NewImage.lastLive && e.dynamodb.NewImage.lastLive.S) {
                  obj.lastLive = e.dynamodb.NewImage.lastLive.S
                }

                if(e.dynamodb.NewImage.lastDone && e.dynamodb.NewImage.lastDone.S) {
                  obj.lastDone = e.dynamodb.NewImage.lastDone.S
                }

                Object.keys(obj).forEach(function(key) {
                  self.$set(self.questions.find(o=>o.id==obj.id),key,obj[key])
                });
              }      
            }

            if(e.eventName == "REMOVE") {
              if(e.dynamodb.Keys) {
                let id = e.dynamodb.Keys.id.S
                let obj = self.questions.find(o=>o.id===id);
                self.$delete(self.questions,self.questions.indexOf(obj));
              }
            }
          });
      },

      exportXlsx: function() {
        var exportData = [];

        this.questions.forEach(obj => {
          let exportObj = {
            id: obj.id,
            timestamp: new Date(obj.timestamp),
            author: obj.author,
            email: obj.email,
            question: obj.question,
            modifiedQuestion: obj.modifiedQuestion,
            status: "neu",
            timestampLive: new Date(obj.lastLive),
            timestampArchive: new Date(obj.lastDone)
          }

          if(obj.live) exportObj.status = "live";
          if(obj.archive) exportObj.status = "archiv";

          exportData.push(exportObj);
        });

        /*global XLSX*/
        var fileName = moment().format("YYYY-MM-DD") + '_FragenExport.xlsx';
        var workSheet = XLSX.utils.json_to_sheet(exportData);
        
        var wb = XLSX.utils.book_new();

        XLSX.utils.book_append_sheet(wb, workSheet, fileName);
        var bin = XLSX.writeFile(wb, fileName, {bookType:'xlsx',type: "binary"});
      }
    },

    computed: {
      questionsNew() {
        return this.questions.filter(question => {
          return !question.live && !question.archive
        })
      },

      questionsLive() {
        return this.questions.filter(question => {
          return question.live && !question.archive
        })
      },

      questionsArchive() {
        return this.questions.filter(question => {
          return question.archive
        })
      },

      filteredQuestions() {
        return this.questions.filter(question => {
          return question.type.toLowerCase().indexOf(this.search.toLowerCase()) > -1
        })
      },

      sortedLiveArray: function() {
        function compare(a, b) {
          let x,y;

          if(a.lastLive && b.lastLive) {
            x = new Date(a.lastLive)
            y = new Date(b.lastLive)
          } 
          else
            return 0

          if (x < y)
            return -1;
          if (x > y)
            return 1;
          return 0;
        }

        return this.questionsLive.slice(0).sort(compare);
      },

      sortedArchiveArray: function() {
        function compare(a, b) {
          let x,y;

          if(a.lastDone && b.lastDone) {
            x = new Date(a.lastDone)
            y = new Date(b.lastDone)
          } 
          else
            return 0

          if (x < y)
            return -1;
          if (x > y)
            return 1;
          return 0;
        }

        return this.questionsArchive.slice(0).sort(compare);
      }
    }
  }
</script>

<style scoped>
  .ui.menu .item>i.icon.rotate {
    animation: rotation 5s infinite linear;
  }

  @keyframes rotation {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }

  .splitcontainer {
    position: fixed;
    top: 40px;
    bottom: 0;
    width: 50vw;
    overflow: auto;
    overflow-y: none;
    z-index: 1;
    padding: 0 2em 4em 2em;

    background: #fff;

    transition: all 1s;
  }

  .splitcontainer.left {
    left: 0;
  }

  .splitcontainer.right {
    right: 0;
  }

  .splitcontainer.solo {
    width:100vw;
    z-index: 10;
  }

  .splitcontainer .ui.secondary.menu {
    background-color: rgba(255,255,255,0.8);
    padding-top: 1em;
  }

  .ui.secondary.pointing.menu {
    position: sticky;
    top: 0;
    z-index: 100;
  }

  #loadingoverlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 1000;
    width: 100vw;
    height: 100vh;
    background: rgba(0,0,0,.2);
  }

  /* Tablet / iPad Portrait */
  @media only screen and (max-width: 991px) {
    .splitcontainer.right {
      display: none !important;
    }

    .splitcontainer.left {
      width: 100vw;
      overflow-x: visible !important;
      height: auto;
      display: block;
    }
  }

  @media print {
    .splitcontainer.right {
      display: none !important;
    }

    .splitcontainer.left {
      overflow-x: initial !important;
      overflow: initial !important;
      height: initial !important;
      display: initial !important;
      position:initial !important;
    }

  .ui.secondary.pointing.menu .item {
      display: none;
    }

    .ui.secondary.pointing.menu .active.item {
      display: inherit;
    }

    .noprint {
      display: none !important;
    }
  }
</style>